/** The old modal: grey heading, message, Cancel / primary button. */
export function ConfirmationBox({
  heading,
  message,
  confirmLabel = "Save",
  onCancel,
  onConfirm,
  children,
}: {
  heading: string;
  message?: string;
  confirmLabel?: string;
  onCancel: () => void;
  onConfirm: () => void;
  children?: React.ReactNode;
}) {
  return (
    <div className="ConfirmationBox shown" role="dialog" aria-label={heading}>
      <div className="backround" onClick={onCancel} />
      <div className="model">
        <div className="heading">{heading}</div>
        <div className="content">
          {message && <p>{message}</p>}
          {children}
          <button className="osx_button" onClick={onCancel}>
            Cancel
          </button>{" "}
          <button className="osx_button primary" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
